module.exports = __webpack_public_path__ + "img/head.c64dca4c.png";